import { UserType } from '../academic/model/user-type';
import { StartAcademicRegistrationPreference } from './model/checkout-sanitized-start-params';

export const getStartAcademicRegistrationPreferenceFromUserType: (userType: UserType) => StartAcademicRegistrationPreference = (userType: UserType) => {
  switch (userType) {
    case 'STUDENT':
      return { type: 'STUDENT' };
    case 'TEACHER':
      return { type: 'TEACHER' };
    case 'ORGANIZATION':
      return { type: 'ORGANIZATION' };
  }
};
